import { Observable } from './zenObservable';
export * from './zenObservable';
export default Observable;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.ecs-deploy.production/build/src/node_modules/apollo-link-dedup/node_modules/zen-observable-ts/lib/index.js
// module id = 7Yau
// module chunks = 20